var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChevronBlueUpCrop = function SvgChevronBlueUpCrop(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 6,
    viewBox: "0 0 9 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.854 5.854a.5.5 0 0 1-.708 0L4.501 2.202.85 5.854a.5.5 0 0 1-.707-.708L4.5.788l4.353 4.358a.5.5 0 0 1 0 .708Z",
    fill: "#116DFF"
  })));
};
export default SvgChevronBlueUpCrop;